<template>
  <div class="index">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>

    <div class="mapCon Center">
      <div class="map">
        <div class="map_bg">
          <img src="../assets/1/map750.png" class="wid100" alt="">
        </div>
        <div class="LootBox">
          <div v-for="box in displayBoxes" :key="box.id" class="box"  :style="{ top: box.top, left: box.left, position: 'absolute' }">
            <img :src="getBoxImage(box.id)" :data-id="box.id" class="boxImg" alt="" @click="handleBoxClick(box.id)">
            <img src="../assets/1/2.png" class="light" alt="">
          </div>
        </div>
        <transition name="fade">
          <Progress v-if="ShowProgress" :ProgressData="ProgressData"></Progress>
        </transition>
          <div class="manBtn">
            <img src="../assets/btn/home.png"  @click="GameBegin" alt="">
          </div>
      </div>
    </div>
    <div class="binocle">
      <img src="../assets/1/binocle.png" class="wid100" alt="">
    </div>

    <transition name="fade">
      <Lottery v-if="showLottery" :LTipsType="LotteryTipsType" @userShare="GameShare" @close="showLottery = false"></Lottery>
    </transition>
    <transition name="fade">
      <BoxShow v-if="showBox" :BoxData="BoxData" @shares="GameShare" @close="showBox = false"></BoxShow>
    </transition>
    <transition name="fade">
      <drawTips v-if="drawMask" @close="requestLottery"></drawTips>
    </transition>

<!--    <transition name="fade">-->
<!--      <shareTips v-if="shareMask" @close="shareAdd"></shareTips>-->
<!--    </transition>-->
<!--    <transition name="fade">-->
<!--      <shareRes v-if="toHomeMask" @close="toHome"></shareRes>-->
<!--    </transition>-->
    <transition name="fade">
      <share v-if="shareBox" @close="shareBox = false"></share>
    </transition>

  </div>
</template>

<script>
import Lottery from "../components/Lottery";
import BoxShow from "../components/BoxShow";
import Progress from "../components/ProgressBar";
import drawTips from "../components/drawTips";
import shareTips from "../components/shareTips";
import shareRes from "../components/shareRes";
import share from "../components/share";
import '@/store' // 确保 setActivePinia 在此处生效
import {reqUserInfo,submitAns,reqDraw } from '@/api';
import {reqShare} from "@/api";
const positions = [
  { top: '5%', left: '0%',url:require('../assets/card/2/1.png') },
  { top: '0%', left: '34%',url:require('../assets/card/2/2.png') },
  { top: '20%', left: '19%',url:require('../assets/card/2/3.png') },
  { top: '21%', left: '54%',url:require('../assets/card/2/4.png')},
  { top: '35%', left: '0%' ,url:require('../assets/card/1/1.png')},
  { top: '41%', left: '35%',url:require('../assets/card/1/2.png') },
  { top: '40%', left: '60%',url:require('../assets/card/1/3.png') },
  { top: '54%', left: '23%',url:require('../assets/card/1/4.png')},
  { top: '60%', left: '3%',url:require('../assets/card/1/5.png') },
  { top: '59%', left: '60%',url:require('../assets/card/1/6.png') },
  { top: '73%', left: '38%',url:require('../assets/card/1/7.png') }
]

// 洗牌算法
function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// 为每个箱子随机分配位置
function createRandomBoxes() {
  const shuffledPositions = shuffleArray(positions)
  return shuffledPositions.map((pos, index) => ({
    id: index + 1,
    ...pos
  }))
}

export default {
  name: "index",
  components: { Lottery, BoxShow, Progress,drawTips,shareTips,shareRes,share},
  data() {
    return {
      displayBoxes: createRandomBoxes(), // 每个箱子随机分配一个位置
      clickedBoxIds: [],
      showRule: false,
      showLottery: false,
      showMyPrize: false,
      showBox: false,
      myPrizeLevel: {
        code:"",
        type:0
      },
      ShowProgress:true,
      BoxData:{},
      ProgressData:0,// 收集宝箱进度
      ShowBegin:false,// 显示开始页面
      IsBegin:true,// 是否显示首页按钮
      drawMask:false,// 抽奖提示
      beginBtn: true,// 是否显示开始寻宝按钮
      DrawBtn: false,// 是否显示抽奖寻宝按钮
      LotteryTipsType: {
        data:null,
        type:-1
      },
      GamePlay:0,
      shareMask:false,
      toHomeMask:false,
      shareBox:false

    }
  },


  created() {
  // let d =  reqUserInfo();
  //   console.log(d)
  //   localStorage.setItem('clickedBoxIds', '')
  },
  mounted() {
    reqUserInfo().then(res => {
      this.fetchClickedBoxes(res)
      if(res.data.treasureCount>=4 && res.data.drawCount>0){
        //宝箱已经收集完
        this.drawMask = true
      }

      this.GamePlay = res.data.drawCount
      if(res.data.drawCount>0){
        this.DrawBtn = true;
      }
    })

  },

  methods: {


    GameBegin(){
      this.$router.replace('/')
    },
    handleBoxClick(id) {
      // if (this.clickedBoxIds.includes(id)) return// 是否可以再次点击
      this.clickedBoxIds.push(id)
      this.saveBoxClick(id)
    },

    getBoxImage(id) {
      if (this.clickedBoxIds.includes(id)) {
        return require('../assets/1/boxopen/' + id + '.png')
      }
      return require('../assets/1/boxclose/' + id + '.png')
    },

    fetchClickedBoxes(res) {
      let list = res.data.ansList;
      this.ProgressData = res.data.treasureCount*25;
      const newArr =list.map(Number)
      try {
        if (newArr) {
          this.clickedBoxIds = newArr
        }
      } catch (e) {}
    },

    saveBoxClick(id) {
      const AnsData = new FormData()
      AnsData.append('ans', id);
      let type= id<=4?1:2
      this.BoxData = {
        type: type,
        id:id,
        url: positions[id-1].url
      }
      submitAns(AnsData).then(res=>{
        if(res.code==200){

          if(type<2 && this.ProgressData<100){
            this.ProgressData +=25;
          }
          if( this.ProgressData>=100){
              this.drawMask = true;
          }
        }
        localStorage.setItem('clickedBoxIds', JSON.stringify(this.clickedBoxIds))
      })
      this.showBox = true  // ✅ 显示 BoxShow 弹窗并传递数据
    },
    //抽奖
    requestLottery() {
      this.LotteryTipsType={
        prizeId:"",
        type:'',
        code:''
      }
      this.drawMask = false;
      this.IsBegin = true;
      this.ShowProgress = false;
      this.showLottery = true;
      this.GamePlay --;
       if(this.GamePlay<=0){
         this.DrawBtn = false;
       }

    },
  //  获取我的奖品
    getMyPrize(){
      reqUserInfo().then(res => {
          this.myPrizeLevel={
            code:res.data.code,
            type:res.data.prizeId,
          }
        this.showMyPrize = true
      })
    },
    //点击开启宝藏按钮
    BeginFun(){
      this.ShowBegin = false;
      reqUserInfo().then(res => {
        if(res.data.treasureCount>=4){
           this.drawMask = true;
        }
      })
    },
    GameShare(){

      this.shareBox = true
    },
    shareAdd(){
      reqShare().then(res=>{
        if(res.code !=500){
          this.toHomeMask = true;
        }
        this.shareMask = false
      })
    },
    toHome(){
      this.$router.replace('/')
    }
  }

}
</script>

<style scoped>
.box {
  width: 80px;
  height: 80px;
}

.boxImg {
  width: 100%;
}
.index {
  width: 100%;
  height: 100%;
  background: url("../assets/1/bg.jpg") center no-repeat;
  background-size: cover;
  overflow-y:  auto;
  overflow-x:  hidden;
  position: relative;
}

.mapCon {
  width: 100%;
  /*margin: -17% 0 0 -13%;*/
  z-index: 2;
  position: relative;
}

.mapCon .map {
  width: 100%;
  position: relative;
  transform: scale(1);
}

.mapCon .map .map_bg {
  width: 100%;
}

.mapCon .title {
  position: absolute;
  top: -9.5%;
  width: 100%;
  text-align: center;
  z-index: 2;
}

/*.mapCon .title{width: 100%; height: 24%; z-index: 2; position: relative;}*/
.mapCon .title img {
  width: 90%;
  margin-left: -1%;
}

.binocle {
  position: fixed;
  width: 30%;
  left: 0;
  bottom: 0;
  vertical-align: middle
}

.binocle img {
  vertical-align: middle
}

.LootBox {
  position: absolute;
  top: 16%;
  left: 10%;
  width: 80%;
  height: 75%;
  z-index: 2;
  pointer-events: none;
}
.LootBox .box {
  position: absolute;
  width: 45%;
  pointer-events: none;
}

.LootBox .box .boxImg {
  position: absolute;
  width: 34%;
  top: 27%;
  left: 33%;
  pointer-events: painted;
}

.LootBox .box .light {
  width: 100%;
  pointer-events: none;
}

.map .manBtn {
  position: absolute;
  bottom: -11%;
  z-index: 20;
  width: 100%;
  text-align: center;
}

.map .manBtn img {
  width: 35%;
  margin: 0 -4%;
}

.mapCon .nav {
  position: absolute;
  right: 1%;
  top: 45%;
  text-align: center;
  width: 20%;
  z-index: 2;
}

.mapCon .nav span {
  display: inline-block;
  padding: 4% 12%;
  margin: 6% 0;
  vertical-align: middle;
  color: #fff;
  font-size: .85rem;
  background-color: #69431b;
  border-radius: 30px;
  cursor: pointer;
}

/* 淡入淡出过渡 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/game.vue